// extracted by mini-css-extract-plugin
export default {"cls1":"FV2a2kXu7R_tIBr8Lbiq","cls2":"sZLToYctNVcnPevwQEmC FV2a2kXu7R_tIBr8Lbiq"};